import React, { useState } from 'react';

const FAQ = ({ data }) => {
  const [expandedItems, setExpandedItems] = useState(new Set([0, 1])); // First two items expanded by default

  const toggleExpanded = (index) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(index)) {
      newExpandedItems.delete(index);
    } else {
      newExpandedItems.add(index);
    }
    setExpandedItems(newExpandedItems);
  };

  return (
    <div className="w-full flex items-center justify-center">
      <div className="bg-white w-12/12 rounded-xl shadow-custom mx-4 px-8 py-7 md:py-10">
        <h2 className="text-2xl  md:text-[28px] font-bold text-deep-blue-70 mb-4">
          Frequently Asked Questions
        </h2>

        <div className="space-y-0">
          {data.map((item, index) => (
            <div
              key={`faq-item-${item.question || index}`}
              className="border-b border-gray-200 last:border-b-0"
            >
              <button
                type="button"
                className={`debuttonify w-full text-left px-0 flex items-center gap-4 transition-all duration-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                  expandedItems.has(index) ? 'min-h-6 py-5' : 'min-h-4 py-5'
                }`}
                onClick={() => toggleExpanded(index)}
                aria-expanded={expandedItems.has(index)}
              >
                <span className="text-2xl text-semibold w-4 h-4 text-gray-90 flex items-center justify-center flex-shrink-0">
                  {expandedItems.has(index) ? (
                    <img
                      src="/public/images/minus-icon.svg"
                      alt="minus-icon"
                      className="w-4 h-4"
                    />
                  ) : (
                    <img
                      src="/public/images/plus-icon.svg"
                      alt="plus-icon"
                      className="w-4 h-4"
                    />
                  )}
                </span>
                <span className="font-semibold text-gray-90 text-base leading-tight flex-1">
                  {item.question}
                </span>
              </button>
              {expandedItems.has(index) && (
                <div className="px-0 pt-1 pb-3 md:pt-0 md:pb-6 pl-8 text-gray-700 leading-relaxed animate-fadeIn">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
